import React from "react";
import PromoSectionData from "./Components/PromoSectionData";
import DocCode from "../DocCode";

const PromoSections = () => {

    // {/* x---------------------------------x Promo Section Code Section x---------------------------------x */}
    const PromoSectionCode =
        `
            <div className="relative overflow-hidden bg-white">
                <div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                    <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
                    <div className="sm:max-w-lg">
                        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">Summer styles are finally here</h1>
                        <p className="mt-4 text-xl text-gray-500">This year, our new summer collection will shelter you from the harsh elements of a world that doesn't care if you live or die.</p>
                    </div>
                    <div>
                        <div className="mt-10">
                        <!-- Decorative image grid -->
                        <div aria-hidden="true" className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl">
                            <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                            <div className="flex items-center space-x-6 lg:space-x-8">
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-01.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-02.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                </div>
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-03.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-04.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-05.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                </div>
                                <div className="grid flex-shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-06.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                    <img src="https://tailwindui.com/plus/img/ecommerce-images/home-page-03-hero-image-tile-07.jpg" alt="" className="h-full w-full object-cover object-center">
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>

                        <Link to="/" className="inline-block rounded-md border border-transparent bg-indigo-600 px-8 py-3 text-center font-medium text-white hover:bg-indigo-700">Shop Collection</Link>
                        </div>
                    </div>
                    </div>
                </div>
            </div>

        `

    return (
        // {/* x---------------------------------x DocCode Component Section x---------------------------------x */}s
        <DocCode
            heading={"Promo Sections"}
            headingText={"Use these Tailwind CSS promo section components to highlight special offers, new arrivals, or featured products with banners and promotional content. These components are designed and built by the Tailwind CSS team, and include a variety of different styles and layouts."}
            code={PromoSectionCode}
            // {/* x---------------------------------x Promo Section Preview Section x---------------------------------x */}s
            Preview={<PromoSectionData />}
        />
    )
}


export default PromoSections;